export default [
  {
    login: "dwpramik",
    id: 3422093,
    node_id: "MDQ6VXNlcjM0MjIwOTM=",
    avatar_url: "https://avatars.githubusercontent.com/u/3422093?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/dwpramik",
    html_url: "https://github.com/dwpramik",
    followers_url: "https://api.github.com/users/dwpramik/followers",
    following_url:
      "https://api.github.com/users/dwpramik/following{/other_user}",
    gists_url: "https://api.github.com/users/dwpramik/gists{/gist_id}",
    starred_url: "https://api.github.com/users/dwpramik/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/dwpramik/subscriptions",
    organizations_url: "https://api.github.com/users/dwpramik/orgs",
    repos_url: "https://api.github.com/users/dwpramik/repos",
    events_url: "https://api.github.com/users/dwpramik/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/dwpramik/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "Corey255A1",
    id: 3460291,
    node_id: "MDQ6VXNlcjM0NjAyOTE=",
    avatar_url: "https://avatars.githubusercontent.com/u/3460291?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Corey255A1",
    html_url: "https://github.com/Corey255A1",
    followers_url: "https://api.github.com/users/Corey255A1/followers",
    following_url:
      "https://api.github.com/users/Corey255A1/following{/other_user}",
    gists_url: "https://api.github.com/users/Corey255A1/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/Corey255A1/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Corey255A1/subscriptions",
    organizations_url: "https://api.github.com/users/Corey255A1/orgs",
    repos_url: "https://api.github.com/users/Corey255A1/repos",
    events_url: "https://api.github.com/users/Corey255A1/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/Corey255A1/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "temirlan248",
    id: 80547826,
    node_id: "MDQ6VXNlcjgwNTQ3ODI2",
    avatar_url: "https://avatars.githubusercontent.com/u/80547826?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/temirlan248",
    html_url: "https://github.com/temirlan248",
    followers_url: "https://api.github.com/users/temirlan248/followers",
    following_url:
      "https://api.github.com/users/temirlan248/following{/other_user}",
    gists_url: "https://api.github.com/users/temirlan248/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/temirlan248/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/temirlan248/subscriptions",
    organizations_url: "https://api.github.com/users/temirlan248/orgs",
    repos_url: "https://api.github.com/users/temirlan248/repos",
    events_url: "https://api.github.com/users/temirlan248/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/temirlan248/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "KingVicky100",
    id: 120860333,
    node_id: "U_kgDOBzQurQ",
    avatar_url: "https://avatars.githubusercontent.com/u/120860333?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/KingVicky100",
    html_url: "https://github.com/KingVicky100",
    followers_url: "https://api.github.com/users/KingVicky100/followers",
    following_url:
      "https://api.github.com/users/KingVicky100/following{/other_user}",
    gists_url: "https://api.github.com/users/KingVicky100/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/KingVicky100/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/KingVicky100/subscriptions",
    organizations_url: "https://api.github.com/users/KingVicky100/orgs",
    repos_url: "https://api.github.com/users/KingVicky100/repos",
    events_url: "https://api.github.com/users/KingVicky100/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/KingVicky100/received_events",
    type: "User",
    site_admin: false,
  },
];
